export const isSameDay = (start_date: string, end_date: string): boolean => {
    const formatted_start_date = start_date ? start_date.substring(0, 10) : '';
    const formatted_end_date = end_date ? end_date.substring(0, 10) : '';
    return !!(formatted_start_date && formatted_end_date && formatted_start_date === formatted_end_date);
};
